import { createContext } from 'react';

type FallbackRender = (errorData: {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError(): void;
}) => React.ReactElement;

type ErrorBoundaryComponent = React.ComponentType<{
  children?: React.ReactNode | (() => React.ReactNode);
  fallback?: React.ReactElement | FallbackRender | undefined;
}>;

type CoreProviderContext<
  TErrorBoundaryComponent extends ErrorBoundaryComponent = ErrorBoundaryComponent,
> = {
  errorBoundaryConfig?: {
    ErrorBoundaryComponent?: TErrorBoundaryComponent;
  };
};

const CoreContext = createContext<CoreProviderContext | undefined>(undefined);

export { CoreContext };
export type { CoreProviderContext };
